
export default {
  data() {
    return {
      issue: [
        {
          name: "متخصص DevOps شرکت …",
          avatar: "avatar.svg",
          company: " … DevOps Engineer at",
          cap: "«ما قطعی و Downtime زیادی داریم که زمان زیادی برای اصلاح آن‌ها لازم است، علاوه بر اینکه نیاز داریم مدام برای دریافت مشاوره فنی، به دنبال متخصصین بگردیم»",
        },
        {
          name: "مدیر محصول شرکت … ",
          avatar: "avatar2.svg",
          company: " … Product Manager at",
          cap: "ما به علت بالا بودن بار هزینه‌های نگهداری و مدیریت زیرساخت، نمی‌توانیم نیروهای خود را کاملا بر اهداف شرکت متمرکز کنیم و سرعت رشد و توسعه پایینی داریم",
        },
        {
          name: "مدیر عامل شرکت …",
          avatar: "avatar3.svg",
          company: " … CEO at",
          cap: "ما بیش از حد بودجه‌مان رو صرف مدیریت و تغییرات زیرساخت IT کردیم که باعث شده در مصارف کلیدی کسب‌وکارمان با محدودیت مواجه شویم",
        },
        {
          name: "متخصص امنیت شبکه شرکت … ",
          avatar: "avatar4.svg",
          company: " … Network security specialist at",
          cap: "به دلیل مشکلات امنیتی در نرم افزار، برخی از دیتاهای حساس سازمان افشا شده و توان جذب متخصص امنیت را نداریم چون هزینه بسیار بالایی دارد؛ لازم است این بخش را برون سپاری کنیم.",
        },
        {
          name: "مدیر فنی شرکت …",
          avatar: "avatar5.svg",
          company: " … Technical Manager at",
          cap: "قسمت IT با دانش روز همگام نیست و این موضوع باعث کاهش کیفیت ارائه خدمات ما شده",
        },
      ],
      showingIndex: 0,
    };
  },
  methods: {
    handleClickCircle(index) {
      this.showingIndex = index;
    },
    nextSlide() {
      if (this.showingIndex < this.issue.length - 1) {
        this.showingIndex++;
      } else {
        this.showingIndex = 0;
      }
    },
    prevSlide() {
      if (this.showingIndex > 0) {
        this.showingIndex--;
      } else {
        this.showingIndex = this.issue.length - 1;
      }
    },
  },
};
